var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_280209790448440171264019092519653791740",
    d: "M15.499 11.317L4.655 5.66 15.499 0v4.683h7.144c2.543 0 4.611 2.12 4.673 4.758l.001.12v7.794c0 2.694-2.093 4.878-4.674 4.878H.935c-.516 0-.935-.437-.935-.976 0-.538.419-.975.935-.975h21.708c1.549 0 2.804-1.31 2.804-2.927V9.56c0-1.616-1.255-2.927-2.804-2.927h-7.144v4.683z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_264437970038879198607865024737613823156",
    d: "M-2.763 -5.884H29.696000000000005V27.737000000000002H-2.763z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_313423114161075904750391152801531146904",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64 -270) translate(48 262) translate(16 8) translate(2.341 5.073)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_185947587900946985036319492224696771341",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_280209790448440171264019092519653791740"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#454545",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_280209790448440171264019092519653791740"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_185947587900946985036319492224696771341)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_264437970038879198607865024737613823156"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_313423114161075904750391152801531146904)",
    xlinkHref: "#hinava_random_uuid_264437970038879198607865024737613823156"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.aa20b48811c90f9729242d60cc2bc521.svg";
export { ForwardRef as ReactComponent };